import React, {useState, useEffect} from "react";
import { useParams } from "react-router-dom";
import Navigation from "../partials/Navigation";
import hviCoverImg from "./../images/hvi-cover-img.jpg";
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import hviQuestions from "../utils/hvi-questions";
import hviQuestionsEn from "../utils/hvi-questions-en";
import {Helmet} from "react-helmet";
import configVars from "../config";
import { setWithExpiry } from '../common';
import HviMessages from "../partials/HVI/HviMessages";
import HviMessagesEn from "../partials/HVI/HviMessagesEn";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import Modal from 'react-bootstrap/Modal';
import HviPersonalSummary from "../partials/HVI/HviPersonalSummary";
import validator from "validator";
import { useTranslation } from "react-i18next";
import HviContentSv from "../partials/HVI/HviContentSv";
import HviContentEn from "../partials/HVI/HviContentEn";
import { useCookies } from "react-cookie";

const OfflineHallbarIndex = () => {

	let intVal = [];

	if ( hviQuestions ) {
		hviQuestions.map( ( hviQuestion ) => 
			hviQuestion.type === 'custom' ? intVal.push({value: ''}) : intVal.push({value: 2})
		)
	}

	const [hviVal, setHviVal] = useState(intVal);
	const [currentStep, setCurrentStep] = useState(0);
	const [saving, setSaving] = useState(false);
	const [hviCount, setHviCount] = useState(0);
	const [displayCount, setDisplayCount] = useState(false);
	const [modelShow, setModelShow] = useState(false);
	const [showEmail, setShowEmail] = useState(false);
	const [userEmail, setUserEmail] = useState('');
	const [errorMsg, setErrorMsg] = useState('');
	const { company } = useParams();
	const [recentHvi, setRecentHvi] = useState([]);
	const [userLang, setUserLang] = useState('sv');

	const [translation] = useTranslation("translations");
	const [cookies] = useCookies(["sc_user_lang"]);

	const [translatedHvuQa, setTranslatedHvuQa] = useState([]);

	const hviLabels = {
		1: '1',
		2: '2',
		3: '3',
		4: '4',
		5: '5',
		6: '6'
	}

	useEffect(() => {

		const queryString = window.location.search;
    	const urlParams = new URLSearchParams(queryString);

		let currentLang = 'sv';

		if (urlParams.get("count")) {

			const count = urlParams.get("count");

			if ( count.length > 0 ) {
				setHviCount(count);
				setDisplayCount(true);
			}

		} else {
			setHviCount(0);
			setDisplayCount(false);
		}

		const chosenLang = urlParams.get("lang");
    	const savedLang = cookies?.sc_user_lang;

		if ( chosenLang ) {
			setUserLang( chosenLang );
			currentLang = chosenLang;
		} else if ( savedLang ) {
			setUserLang( savedLang );
			currentLang = savedLang;
		}

		if ( currentLang === 'en' ) {
			setTranslatedHvuQa( hviQuestionsEn );
		} else {
			setTranslatedHvuQa( hviQuestions );
		}

	}, [cookies.sc_user_lang]);

	const handleHviUpdate = (val, updatedIndex) => {

		const valInt = parseInt( val, 10 );

		const newHvi = hviVal.map( (obj, index ) => 
			index === updatedIndex ? { ...obj, value: valInt } : obj
		);

		setHviVal( newHvi );

	}

	const handleCompletedPercentage = ( current, total ) => {
		return ((current+1)/total)*100
	}

	const getHviColor = (count) => {
		let color = 'sy-red';

		if ( count > 24 && count < 60 ) {
			color = 'sy-yellow';
		}

		if ( count > 59 ) {
			color = 'dark-green';
		}

		return color;
	}

	const saveUserHvi = async () => {

		if ( !userEmail.toString().trim().length || !validator.isEmail(userEmail) ) {
			setErrorMsg(translation("enter_valid_email"));

			return;
		
		}  else {
			setErrorMsg('');
		}

		setSaving( true );

		const response = await fetch(
			`${configVars.apiUrl}sustainchange/v1/saveofflineuserhvi/?email=${userEmail}&hvidata=${JSON.stringify(hviVal)}&company=${company}`,
			{
				method: "GET",
				headers: {
					Authorization: `Basic ${configVars.auth}`,
				},
			}
		);
		
		const hviResponse = await response.json();

		if ( hviResponse ) {
			
			if ( hviResponse.success === true ) {

				if ( hviResponse.data.recent_hvi ) {

					setRecentHvi( [ hviResponse.data.recent_hvi ] );
					
					setWithExpiry( `sy_recent_hvi`, [ hviResponse.data.recent_hvi ] );

					setHviCount( hviResponse.data.recent_hvi.hvi_count );

					setDisplayCount(true);
					setModelShow(false);

				}

			} else {

				setErrorMsg( hviResponse.message );

			}



		}

		setSaving( false );

	}

	const showResultsOnClose = () => {

		if ( currentStep > 11 ) {

			let totalHvi = 0;

			hviVal.map( (hviItem, index) => {
				if ( index < 12 ) {
					totalHvi = totalHvi + hviItem.value;
				}

				return hviItem;
			});

			setHviCount( totalHvi );
			setDisplayCount(true);

			let today = new Date().toISOString().slice( 0, 10 );

			const newHvi = [
				{
					'data': hviVal,
					'date': today,
					'hvi_count': totalHvi,
				}
			];

			setWithExpiry( `sy_recent_hvi`, newHvi );

			setRecentHvi( newHvi );
		}

	}

	return (
		<div className="main-wrapper">
			<Helmet>
				<title>{translation('hvi_title')}</title>
				<meta name="description" content="" />
			</Helmet>
			<Navigation />

			<div className="page-content-wrap">
				<HorizontalNav title={translation("welcome")} />
				
				<div className="pt-5 pt-lg-0 page-content-inner">
					<div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px',backgroundImage: `url(${hviCoverImg})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '300px'}}>
						<div className="position-absolute w-100 h-100 top-0 left-0 dark-overlay d-flex justify-content-center align-items-center">
							<h1 className="text-white display-1 text-center text-shadow">{translation('hvi_title')}</h1>
						</div>
					</div>

						<div className="px-4" style={{maxWidth: '1400px'}}>
							<div className="hvi-wrap mt-5">

								{ displayCount &&
									<>
										<div className="display-count-wrap d-flex align-items-center">
											<h3 className="h1 fw-bold me-2">{translation('your_hvi_is')}:</h3>
											<span className={`hvi-count text-white text-center h2 mb-0 py-3 bg-${getHviColor(hviCount)}`} style={{width: '150px'}}>{hviCount}</span>
										</div>
										<div className="mt-5">
											{userLang === 'sv' &&
												<HviMessages count={hviCount} color={getHviColor(hviCount)} />
											}
	
											{userLang === 'en' &&
												<HviMessagesEn count={hviCount} color={getHviColor(hviCount)} />
											}
										</div>

										<HviPersonalSummary isNew={false} userHvi={recentHvi} lang={userLang} />

										{/* <div className="mt-5 mb-6">
											<Link to={`/${company}/hvi/`} className="btn btn-halite-blue rounded-pill btn-lg px-5" onClick={ () => {setHviCount(0);setDisplayCount(false);setShowEmail(false)}}>
												<i className="fa fa-life-ring" aria-hidden="true"></i>
												<span className="ms-3">{translation('go_to_test')}</span>
											</Link>
										</div> */}
									</>
								}

								{ translatedHvuQa && translatedHvuQa.length > 0 && !displayCount &&
									<>
										<div className="hvi-content mb-5">

											<div className="row">
												<div className="col-12 col-lg-9">
													{userLang === 'sv' &&
														<HviContentSv />
													}

													{userLang === 'en' &&
														<HviContentEn />
													}

													<div className="mb-4">
														<button type="button" className="btn btn-halite-blue rounded-pill btn-lg px-5" onClick={()=> setModelShow(true)}>
															<i className="fa fa-life-ring" aria-hidden="true"></i>
															<span className="ms-3">{translation('test_hvi_btn')}</span>
														</button>
													</div>

													<Modal
														show={modelShow}
														onHide={() => {setModelShow(false); showResultsOnClose();}}
														backdrop="static"
														keyboard={false}
														centered
														size="lg"
														className="hvi-model-wrap"
													>
														<Modal.Header closeButton>
															<Modal.Title>
																{ showEmail &&
																	<span>{translation('one_step_left')}</span>
																}
															</Modal.Title>
														</Modal.Header>
														<Modal.Body className="hvi-model">

															{ !showEmail &&
																<div className="toast show mb-5" role="alert" aria-live="assertive" aria-atomic="true">
																	<div className="toast-header">
																		<strong className="me-auto">{translation('hvi_test_title')}</strong>
																		<small className="text-muted">{currentStep+1}/{translatedHvuQa.length}</small>
																	</div>
																	<div className="progress rounded-0" style={{height: '7px'}}>
																		<div className="progress-bar progress-bar-striped progress-bar-animated bg-sea-green rounded-0" role="progressbar" aria-valuenow={handleCompletedPercentage(currentStep, translatedHvuQa.length)} aria-valuemin="0" aria-valuemax="100" style={{width: `${handleCompletedPercentage(currentStep, translatedHvuQa.length)}%`}}></div>
																	</div>
																	<div className="toast-body">
																		<div className="hvi-single pb-4 mt-2">
																			<label >
																				<span className="fw-bold pe-2">{currentStep+1})</span>
																				<span>{translatedHvuQa[currentStep].title}</span>
																			</label>
																			{translatedHvuQa[currentStep].hints &&
																				<>
																					{translatedHvuQa[currentStep].hints.map( (hint, index) => {
																						return (
																							<div className="form-text ps-2" key={index}>{hint}</div>
																						)
																					})}
																					
																				</>
											
																			}
																			{translatedHvuQa[currentStep].type === 'numbers' &&
																				<Slider
																					value={hviVal[currentStep].value}
																					onChange={(value) => handleHviUpdate(value, currentStep)}
																					min={1}
																					max={6}
																					labels={hviLabels}
																				/>
																			}

																			{translatedHvuQa[currentStep].type === 'custom' && translatedHvuQa[currentStep].choices?.length > 0 &&
																				<div className="hvi-choices-wrap mt-3">
																					{ translatedHvuQa[currentStep].choices.map( (choice, index) => {
																						return (
																							<div className={`form-check ${translatedHvuQa[currentStep].display === 'inline' ? 'form-check-inline' : '' }`} key={index}>
																								<input 
																									className="form-check-input"
																									type="radio"
																									id={`${translatedHvuQa[currentStep].name}_${index}`} 
																									name={translatedHvuQa[currentStep].name} 
																									value={index}
																									checked={ hviVal[currentStep].value === index }
																									onChange={ (event) => { handleHviUpdate(event.target.value, currentStep) } }
																								/>
																								<label className="form-check-label" htmlFor={`${translatedHvuQa[currentStep].name}_${index}`}>{choice}</label>
																							</div>
																						)
																					}) }
																				</div>
																			}
																		</div>
																		<div className="mt-3 pt-3 border-top d-inline-block w-100">
																			{currentStep > 0 &&
																				<button type="button" className="btn btn-primary btn-sm text-white pe-4 ps-3" onClick={() => setCurrentStep(currentStep-1)}>
																					<i className="fa fa-angle-left" aria-hidden="true"></i>
																					<span className="ps-3">{translation('back')}</span>
																				</button>
																			}
																			{ (currentStep+1) < translatedHvuQa.length &&
																				<button type="button" className="btn btn-primary btn-sm float-end text-white ps-4 pe-3" onClick={() => setCurrentStep(currentStep+1)}>
																					<span className="pe-3">{translation('next')}</span>
																					<i className="fa fa-angle-right" aria-hidden="true"></i>
																				</button>
																			}
																			{ (currentStep+1) === translatedHvuQa.length &&
																				<button type="button" className="btn btn-sea-green btn-sm float-end text-white px-3" onClick={ () => setShowEmail(true) }>
																					<span>{translation('calculate_hvi')}</span>
																				</button>
																			}
															
																		</div>
																	</div>
																</div>
															}

															{showEmail &&
																<div className="save-offline-wrap pb-3" >
																	{ errorMsg.length > 0 &&
																		<div className="row">
																			<div className="col-12">
																				<p className="text-sy-red">{errorMsg === 'already_answered' ? translation(errorMsg) : errorMsg }</p>
																			</div>
																		</div>
																	}
																	<div className="row">
																		<div className="col-12 mb-2">
																			<p>{translation('hvi_email_msg')}</p>
																		</div>
																	</div>
																	<div className="row">
																		<div className="col-8">
																			<input type="email" className="form-control" placeholder={translation('your_email')} value={userEmail} onChange={ (e) => setUserEmail(e.target.value) } />
																		</div>
																		<div className="col-4">
																			<button type="button" className="btn btn-sea-green btn-sm text-white px-3 py-2" onClick={() => saveUserHvi()}>
																				<span>{translation('save')}</span>
																				{saving &&
																					<div className="spinner-border text-light spinner-border-sm ms-2" role="status" >
																						<span className="visually-hidden">Loading...</span>
																					</div>
																				}
																			</button>
																		</div>
																	</div>
																</div>
															}

														</Modal.Body>
													</Modal>

													

												</div>
											</div>

											{/* <div className="mb-4 mt-4 text-center">
												<h3 className="fw-bold">Hur är testet framtaget?</h3>
												<p>Frågorna är formulerade utifrån utmaningar i vår samtid – stress, sömn, återhämtning, gränsen mellan arbete och fritid – plus två klassiska modeller, KASAM samt Karasek och Theorells krav-kontroll-stöd-modell.</p>
											</div> */}

											
										</div>
										
									</>
								}
							</div>
						</div>
				</div>

			</div>
		</div>
	);
};

export default OfflineHallbarIndex;
